import { Card } from 'primereact/card';
import React from 'react';
import { useNavigate } from 'react-router-dom';

export const MindmapCard = () => {
  const navigate = useNavigate();

  const onCardClick = () => navigate('123');

  const header = <img className="header-image" src="https://picsum.photos/900/500" />;

  return <Card title="Ideen WIP1" onClick={onCardClick} className="grid-tab" header={header} />;
};
